<template>
    <div class="w-full h-full flex flex-col overflow-auto mt-2">
        <div class="flex flex-col h-3/4 overflow-auto items-center">
            <div class="w-3/4 border border-gray-300 shadow-sm rounded m-1 flex" v-for="step in workflowSteps" :key="step.id">
                <div v-if="stepExists(step)"  class="w-full flex bg-gray-300 h-full">
                    <div class="border-r border-r-gray-300 h-full flex items-center justify-center w-5">
                        <input disabled type="checkbox">
                    </div>
                    <div class="py-1 px-2">
                        {{ step.step_name }} - Already exists
                    </div>
                </div>
                <div v-else @click="addOrRemove(step)" class="w-full flex h-full hover:cursor-pointer">
                    <div class="border-r border-r-gray-300 h-full flex items-center justify-center w-5">
                        <input class="hover:cursor-pointer" :checked="shouldAddStep(step)" type="checkbox">
                    </div>
                    <div class="py-1 px-2">
                        {{ step.step_name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex justify-center mt-2 items-center border-t pt-2"><base-button-affirmative @click="addSteps">Add</base-button-affirmative></div>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits } from 'vue';

const props = defineProps(['workflowSteps', 'client'])
const emits = defineEmits(['add-workflow-steps'])

function stepExists(step){
    return props.client.workflow_steps.map((clientWorkflowStep) => {
        return clientWorkflowStep.workflow_step.id
    }).includes(step.id)
}

const stepsToAdd = ref([])

function shouldAddStep(step){
    return stepsToAdd.value.map((workflowStep) => {
        return workflowStep.id
    }).includes(step.id)
}

function addOrRemove(step){
    if(shouldAddStep(step)){
        stepsToAdd.value.splice(stepsToAdd.value.findIndex((workflowStep) => workflowStep.id == step.id), 1)
    } else {
        stepsToAdd.value.push(step)
    }
}

function addSteps(){
    const data = {
        workflow_steps: stepsToAdd.value.map((step) => {
            return {
                client_id: props.client.id,
                workflow_step_id: step.id
            }
        })
    }
    emits('add-workflow-steps', data)
}

</script>